export default "/images/vendor/flag-icons/flags/1x1/ve.svg?566e10866c917e59bb97d6f78dfd3d44";